export const initialVehicleDetailState = {
  status: 'idle',
  data: null,
  error: null,
};

export const createVehicleDetailLoader = ({ request, onStateChange }) => {
  let sequence = 0;
  let inFlight = null;
  let loadedId = null;
  let disposed = false;

  const load = (vehicleId) => {
    const normalizedId = Number(vehicleId);
    if (disposed || !Number.isInteger(normalizedId) || normalizedId <= 0) {
      return Promise.resolve(null);
    }
    if (loadedId === normalizedId) return Promise.resolve(null);
    if (inFlight?.vehicleId === normalizedId) return inFlight.promise;

    sequence += 1;
    const currentSequence = sequence;
    inFlight?.controller.abort();
    const controller = new AbortController();
    onStateChange({ status: 'loading', data: null, error: null });

    const promise = Promise.resolve()
      .then(() => request(normalizedId, { signal: controller.signal }))
      .then((data) => {
        if (disposed || currentSequence !== sequence) return null;
        loadedId = normalizedId;
        onStateChange({ status: 'success', data, error: null });
        return data;
      })
      .catch((error) => {
        if (disposed || currentSequence !== sequence || error?.name === 'AbortError') return null;
        onStateChange({
          status: 'error',
          data: null,
          error: error?.message || 'No fue posible cargar la información del vehículo.',
        });
        return null;
      })
      .finally(() => {
        if (currentSequence === sequence) inFlight = null;
      });

    inFlight = { vehicleId: normalizedId, controller, promise };
    return promise;
  };

  const dispose = () => {
    disposed = true;
    sequence += 1;
    inFlight?.controller.abort();
    inFlight = null;
  };

  return { load, dispose };
};
